var React = require('react');

function MiddleRibbon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#1b262c","stroke":"#1b262c","strokeWidth":".57","d":"M158.983 177.139h676.249v161.868H158.983z","transform":"matrix(1.183 .00096 1.11526 .89845 -385.016 -158.957)"}));
}

MiddleRibbon.defaultProps = {"viewBox":"0 0 981 146","fillRule":"evenodd","clipRule":"evenodd","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"1.5"};

module.exports = MiddleRibbon;

MiddleRibbon.default = MiddleRibbon;
